import {useMemo} from 'react'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'

import {ChatViewer} from './chatSurface'

/** The signed-in state, user type and applicant flag that pick Versi's surface and endpoint. */
export function useChatViewer(): ChatViewer {
  const isLoggedIn = useSelector((state: RootState) => Boolean(state.userReducer.isLoggedIn))
  const userType = useSelector((state: RootState) => state.userReducer.userType || null)
  const isAdmissionUser = useSelector((state: RootState) =>
    Boolean(state.userReducer.isAdmissionUser)
  )
  return useMemo(
    () => ({isLoggedIn, userType, isAdmissionUser}),
    [isLoggedIn, userType, isAdmissionUser]
  )
}
